import { render } from "./HeroiconsOutlineDocument.vue?vue&type=template&id=223f3098"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineDocument.vue"]])

export default __exports__